// React
import React, { Suspense, useEffect, useState } from "react";
// Framework
import { ActivityPlaceholder } from "activity";
import { useMounted } from "hooks";
import { usePortal } from "stack/core";

////////////////////////////////////////////////////
/// Component
////////////////////////////////////////////////////

export const PortalLayoutContent = () => {
  // Framework
  const { apps } = usePortal();
  const { callWhenMounted } = useMounted();
  // State
  const [loader, setLoader] = useState(false);
  // Effect
  useEffect(() => {
    return apps.onChange(
      callWhenMounted(() => {
        setLoader(apps.current?.loader);
      }),
      true
    );
  }, [callWhenMounted, apps]);
  // Render
  return (
    <Suspense fallback={<ActivityPlaceholder token="ui:portal:loader" />}>
      {loader}
    </Suspense>
  );
};

export default PortalLayoutContent;
